import * as Yup from "yup";
import {
  PASSWORD_REGEX_WITH_SPECIAL_CHARACTERS,
  WHITE_SPACES_REGEX,
  PASSWORD_MAX_LIMIT,
  PASSWORD_MIN_LIMIT,
} from "../constants";

export const myAccountResetPasswordFieldNames = {
  OLD_PASSWORD: "oldPassword",
  CONFIRM_PASSWORD: "confirmPassword",
  PASSWORD: "password",
};

export const myAccountInitialValues = {
  [myAccountResetPasswordFieldNames.CONFIRM_PASSWORD]: "",
  [myAccountResetPasswordFieldNames.PASSWORD]: "",
  [myAccountResetPasswordFieldNames.OLD_PASSWORD]: "",
};

export const myAccountValidationSchema = (intl) =>
  Yup.object().shape({
    [myAccountResetPasswordFieldNames.OLD_PASSWORD]: Yup.string().required(
      intl.formatMessage({ id: "login.fieldError.password.required" })
    ),
    [myAccountResetPasswordFieldNames.PASSWORD]: Yup.string()
      .required(
        intl.formatMessage({ id: "login.fieldError.password.required" })
      )
      .matches(
        WHITE_SPACES_REGEX,
        intl.formatMessage({ id: "login.fieldError.password.invalid" })
      )
      .min(
        PASSWORD_MIN_LIMIT,
        intl.formatMessage({ id: "login.fieldError.password.min" })
      )
      .max(
        PASSWORD_MAX_LIMIT,
        intl.formatMessage({ id: "login.fieldError.password.max" })
      )
      .matches(
        PASSWORD_REGEX_WITH_SPECIAL_CHARACTERS,
        intl.formatMessage({ id: "login.fieldError.password.invalid" })
      ),
    [myAccountResetPasswordFieldNames.CONFIRM_PASSWORD]: Yup.string()
      .required(
        intl.formatMessage({ id: "login.fieldError.password.required" })
      )
      .oneOf(
        [Yup.ref("password"), null],
        intl.formatMessage({ id: "login.passwordsDoNotMatch" })
      ),
  });
